import { render } from "./UserLdapTable.vue?vue&type=template&id=c1489184&scoped=true&ts=true"
import script from "./UserLdapTable.vue?vue&type=script&lang=ts"
export * from "./UserLdapTable.vue?vue&type=script&lang=ts"

import "./UserLdapTable.vue?vue&type=style&index=0&id=c1489184&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1489184"]])

export default __exports__